import { Link } from 'gatsby'
import React from 'react'
import styled from 'styled-components'
import Logo from '../images/incentive-trip-logo.svg'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  grid-column: 1 / -1;
  margin-top: 8px;
  text-align: center;

  &,
  a,
  svg {
    color: ${(props) => props.theme.colors.darkText};
  }

  p {
    margin: 0;
  }

  svg {
    width: 170px;
    margin-bottom: 8px;
  }

  @media screen and (min-width: ${(props) => props.theme.responsive.medium}) {
    svg {
      width: 200px;
    }
  }

  @media screen and (min-width: ${(props) => props.theme.responsive.large}) {
    svg {
      width: 324px;
    }
  }
`

const Detail = styled.p`
  font-size: 10px;
  line-height: 16px;
  font-weight: 500;
  text-transform: uppercase;

  span {
    + span {
      border-left: 1px solid currentColor;
      margin-left: 6px;
      padding-left: 6px;
    }
  }

  @media screen and (min-width: ${(props) => props.theme.responsive.large}) {
    font-size: 14px;
    line-height: 20px;
  }
`

const IncentiveTripHeader = (props) => (
  <Wrapper {...props}>
    <Link to="/events/incentive-trip/">
      <Logo />
    </Link>
    <Detail>
      <span>Feb 22 - Feb 27</span>
      <span>Punta Cana, DR</span>
    </Detail>
  </Wrapper>
)

export default IncentiveTripHeader
